import { render } from "./KennelNavi.vue?vue&type=template&id=494b4f10&scoped=true"
import script from "./KennelNavi.vue?vue&type=script&lang=js"
export * from "./KennelNavi.vue?vue&type=script&lang=js"

import "./KennelNavi.vue?vue&type=style&index=0&id=494b4f10&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494b4f10"]])

export default __exports__